import React, { useState, useEffect } from 'react';
import { MdArrowForwardIos } from "react-icons/md";
import { MdOutlineShoppingCart } from "react-icons/md";
import { useNavigate,useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Footer from '../components/Footer';
import { getCall, postCall } from './../utils/Network';
import { removeItemFromCart } from "../slices/signUp";
import { useTranslation } from 'react-i18next';
import './css/shoppingcart.css';
const ApiKey = process.env.REACT_APP_API_KEY;


// Shopping Cart component

const ShoppingCart = () => {

    const cart = useSelector(state => state.signup.cart)
    const { t } = useTranslation()

    const navigate = useNavigate();
    let params = useParams();
    const [userData, setUserData] = useState({})
    const [totalPrice, setTotalPrice] = useState(0);
    const [couponCode, setCouponCode] = useState("");
    const associationResponse = useSelector((state) => state.signup.associateId);

    const token = useSelector((state) => state.signup.token);
    const dispatch = useDispatch();



    const myHeaders = { "API-key": ApiKey }
    useEffect(() => {
        fetchAssociateData();
    }, []);

    useEffect(() => {
        if (userData.associateId) {
            calculateTotalPrice();
        }
    }, [userData, cart, couponCode]);

    useEffect(() => {
        const html = document.getElementsByTagName('html')[0];
        html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
        html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
        window.Webflow && window.Webflow.destroy();
        window.Webflow && window.Webflow.ready();
        window.Webflow && window.Webflow.require('ix2').init();
        document.dispatchEvent(new Event('readystatechange'))
    }, [])


    // Fetch Associate Data Function

    const fetchAssociateData = async () => {
        const id = associationResponse;


        const response = await getCall({ url: 'getAssociate', urlParams: { associateid: id }, header: myHeaders });

        if (response?.data) {
            setUserData(response?.data)
        }
    }

    // Navigate Function
    const fnNavigate = () => {
        navigate("/checkout");
    }

    const fnBack = () => {
        navigate('/review');
    }
    //  Remove From Cart Function
    const removeFromCart = (productToRemove) => {
        dispatch(removeItemFromCart(productToRemove));
    }


    // Calculate Total Price Function
    const calculateTotalPrice = async () => {

        let shipping = userData && userData.shippingAddress && userData.shippingAddress[0];


        const bodyData = {
            currencyCode: "usd",
            shipMethodId: 1,
            storeId: 1,
            shippingAddress: {
                line1: shipping && shipping.line1,
                line2: shipping && shipping.line2,
                state: shipping && shipping.state,
                city: shipping && shipping.city,
                zip: shipping && shipping.zip,
                countryCode: shipping && shipping.countryCode
            },
            associateId: associationResponse || 0,
            orderTypeId: 1,
            associateType: 1,
            orderDetails: Object.keys(cart).map(key => ({
                itemId: cart[key].id,
                quantity: cart[key].quantity
            })),
            orderCoupons: [
                {
                    couponCode: couponCode ? couponCode : "coupon!",
                }
            ]
        };

        try {
            const myHeaders = { "Authorization": "Bearer " + token }
            const response = await postCall({
                url: 'calculatePrice',
                bodyData,
                header: myHeaders
            });

            if (response?.data) {
                setTotalPrice(response.data.subTotal);
            }
        } catch (error) {
            console.log('Error calculating total price:', error);
        }

    };

    const checkKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); e.stopPropagation();
        }
    }

    return (
        <div className='theme-bg'>
            <div className='enrollment-navbar'><div className='noa-logo heading-margin'></div></div>
            <div className="shopping-cart-page">
                <div className='cart-grid-contaner' >
                    <div className="pricing-box">
                        <div className="pricing-name">
                            <b>{t('cart')}</b>
                            <div className="primary-button-wrapper summary-explore-btn"><a href="/enrollment-kit" className="inner-button w-inline-block">
                                <div className="primary-button-border-wrap">
                                    <div className="inner-button-wrap">
                                        <div className="inner-button-text-wrap">
                                            <div className="inner-button-text">{t("exploreMoreProducts")}</div>
                                            <div className="inner-button-hover-text">{t("exploreMoreProducts")}</div>
                                        </div>
                                        <div className="inner-button-star-wrap"><img loading="lazy" src="/images/inner-button-star-1.svg" alt=""
                                            className="inner-button-star _1" /><img loading="lazy" src="/images/inner-button-star-2.svg" alt=""
                                                className="inner-button-star _2" /><img loading="lazy" src="/images/inner-button-star-3.svg" alt=""
                                                    className="inner-button-star _3" /></div>
                                        <div className="inner-button-hover-bg"></div>
                                    </div>
                                </div>
                                <div className="line-wrap-inner">
                                    <div className="inner-line-wrap _1">
                                        <div className="line"></div>
                                        <div className="line _2"></div>
                                    </div>
                                    <div className="inner-line-wrap _2">
                                        <div className="line _3"></div>
                                        <div className="line _4"></div>
                                    </div>
                                    <div className="inner-line-wrap _3">
                                        <div className="line _5"></div>
                                        <div className="line _6"></div>
                                    </div>
                                    <div className="inner-line-wrap _4">
                                        <div className="line _7"></div>
                                        <div className="line _8"></div>
                                    </div>
                                </div>
                            </a></div>
                        </div>
                        <ul>
                            {Object.keys(cart).length > 0 && Object.keys(cart).map((key) => (<li><div className="pricing-footer">
                                <div className="pricing-footer-left">{cart[key].name}</div>
                                <div className="pricing-footer-right">
                                    <label>{`$${(cart[key].price * cart[key].quantity)?.toFixed(2)}`}</label>
                                    <button className="btn-trash"><i className="fas fa-trash" onClick={() => { removeFromCart(cart[key]) }}></i></button>
                                </div>
                            </div></li>))}
                        </ul>

                    </div>
                    <div className="pricing-box">
                        <div className="pricing-name">
                            <b>{t('summary')}</b>

                        </div>
                        <div className="pricing-tax">
                            <div className="pricing-row">
                                <label className="left-label">{t('itemSubTotal')} : </label><label className="right-label">${totalPrice?.toFixed(2) ?? 0}</label>
                            </div>
                            <div className="pricing-row">
                                <label className="left-label">{t('total')} : </label>
                                <label className="right-label">${totalPrice?.toFixed(2) ?? 0}</label>
                            </div>
                            <div className="pricing-row">
                                <label className="left-label">{t('discount')} : </label>
                                <label className="right-label">${0}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-footer-button-wrapper'>
                    <div className="navbar-button-wrapper">
                        <div className="primary-button-wrapper">
                            <a href='#' onKeyDown={(e) => { checkKeyPress() }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); fnBack() }}
                                data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6" className="primary-button w-inline-block">
                                <div className="primary-button-border-wrap">
                                    <div className="primary-button-wrap">
                                        <div className="primary-button-text">⟵ &nbsp;&nbsp;Back</div>
                                        <div className="primary-button-hover-text">⟵ &nbsp;&nbsp;Back</div>
                                        <div className="primary-button-hover-bg"></div>
                                    </div>
                                </div>
                                <div className="line-wrap">
                                    <div className="primary-line-wrap _1">
                                        <div className="line _1"></div>
                                        <div className="line _2"></div>
                                    </div>
                                    <div className="primary-line-wrap _2">
                                        <div className="line _3"></div>
                                        <div className="line _4"></div>
                                    </div>
                                    <div className="primary-line-wrap _3">
                                        <div className="line _5"></div>
                                        <div className="line _6"></div>
                                    </div>
                                    <div className="primary-line-wrap _4">
                                        <div className="line _7"></div>
                                        <div className="line _8"></div>
                                    </div>
                                </div>
                            </a></div>
                        <div className="menu-button w-nav-button">
                            <div data-is-ix2-target="1" className="hamburger-menu-icon" data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                                data-animation-type="lottie" data-src="/images/hamburger-20menu.lottie" data-loop="0"
                                data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-ix2-initial-state="0">
                                <span style={{ color: "#ffffff" }}>
                                    <img src="/images/Hamburger_icon.png" alt="" style={{ width: "30%" }} />

                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="navbar-button-wrapper">
                        <div className="primary-button-wrapper">
                            <a href='#' onKeyDown={(e) => { checkKeyPress() }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); fnNavigate() }}
                                data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6" className="primary-button w-inline-block">
                                <div className="primary-button-border-wrap">
                                    <div className="primary-button-wrap">
                                        <div className="primary-button-text">{t('proceedToCheckout')} <span className='sep'></span> <MdOutlineShoppingCart /></div>
                                        <div className="primary-button-hover-text">{t('proceedToCheckout')} <span className='sep'></span> <MdOutlineShoppingCart /></div>
                                        <div className="primary-button-hover-bg"></div>
                                    </div>
                                </div>
                                <div className="line-wrap">
                                    <div className="primary-line-wrap _1">
                                        <div className="line _1"></div>
                                        <div className="line _2"></div>
                                    </div>
                                    <div className="primary-line-wrap _2">
                                        <div className="line _3"></div>
                                        <div className="line _4"></div>
                                    </div>
                                    <div className="primary-line-wrap _3">
                                        <div className="line _5"></div>
                                        <div className="line _6"></div>
                                    </div>
                                    <div className="primary-line-wrap _4">
                                        <div className="line _7"></div>
                                        <div className="line _8"></div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShoppingCart;